export const formatReadingTime = (minutes) => `${minutes} min read`;

export const keysExist = (...keys) => (node) => {
  for(let k of keys) {
    if (!node[k]) return false;
  }
  return true;
};

export const getPath = slug => `/news${slug}`;